<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>用户数据</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>数据中心</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>

    <el-row :gutter="20">
      <el-col :span="5">
        <div class="dis_jcsb box-cell mar_B_20">
          <div class="box-icon box-icon-bg1 ft32">
            <i class="el-icon-user"></i>
          </div>
          <div class="box-title">
            <div class="online">
              <count-to :startVal="0" :endVal="user_total" :duration="3000"></count-to>
            </div>
            <div class="yestaday">会员总人数</div>
          </div>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="dis_jcsb box-cell mar_B_20">
          <div class="box-icon box-icon-bg2 ft32">
            <i class="el-icon-user-solid"></i>
          </div>
          <div class="box-title">
            <div class="online">
              <count-to :startVal="0" :endVal="user_online" :duration="3000"></count-to>
            </div>
            <div class="yestaday">在线会员</div>
          </div>
        </div>
      </el-col>
      <el-col :span="5">
        <div class="dis_jcsb box-cell mar_B_20">
          <div class="box-icon box-icon-bg3 ft32">
            <i class="el-icon-share"></i>
          </div>
          <div class="box-title">
            <div class="online">
              <count-to :startVal="0" :endVal="user_active" :duration="3000"></count-to>
            </div>
            <div class="yestaday">活跃会员</div>
          </div>
        </div>
      </el-col>
      <el-col :span="5">
        <div class="dis_jcsb box-cell mar_B_20">
          <div class="box-icon box-icon-bg4 ft32">
            <i class="el-icon-time"></i>
          </div>
          <div class="box-title">
            <div class="online">
              <count-to :startVal="0" :endVal="user_vip" :duration="3000"></count-to>
            </div>
            <div class="yestaday">VIP会员</div>
          </div>
        </div>
      </el-col>
      <el-col :span="5">
        <div class="dis_jcsb box-cell mar_B_20">
          <div class="box-icon">
            <i class="el-icon-female"></i>
          </div>
          <div class="box-title">
            <div class="online">
              <count-to :startVal="0" :endVal="user_svip" :duration="3000"></count-to>
            </div>
            <div class="yestaday">VIP续费会员</div>
          </div>
        </div>
      </el-col>
    </el-row>

    <div>
      <el-row class="mt10">
        <el-col :span="16" class="pr5 mb10">
          <el-card>
            <div id="maps" style="width: 1200px; height: 700px"></div>
          </el-card>
          <div class="users_list" style="padding-top: 30px;">
            <div class="title ftw_bold">排名</div>
            <div class="title ftw_bold">地区</div>
            <div class="title ftw_bold">增长人数</div>
            <div class="title ftw_bold">增长占比</div>
            <div class="title ftw_bold">会员人数</div>
            <div class="title ftw_bold">人数占比</div>
          </div>
          <blockquote v-for="(item,index) in province" :key="index">
            <div class="users_list" v-if="item.total > 0">
              <div class="title">{{index+1}}</div>
              <div class="title">{{item.ntitle}}</div>
              <div class="title">--</div>
              <div class="title">--</div>
              <div class="title">{{item.total}}</div>
              <div class="title" style="padding-top:15px;text-align: left;">
                <el-progress stroke-width="10" :percentage="item.rang"></el-progress>
              </div>
            </div>
          </blockquote>
          <div class="users_list" style="padding-bottom: 30px;"></div>
        </el-col>

        <el-col :span="8" class="pr5 mb10">
          <el-card>
            <div slot="header">
              <span>会员等级统计</span>
            </div>
            <div id="pie2" style="width: 300px; height: 300px;"></div>
            <div class="data_list">
              <div class="li">
                <div class="title ftw_bold">等级</div>
                <div class="title ftw_bold">数量</div>
                <div class="title ftw_bold">占比</div>
              </div>
              <div class="li">
                <div class="title">普通用户</div>
                <div class="title">10</div>
                <div class="title">20%</div>
              </div>
              <div class="li">
                <div class="title">vip</div>
                <div class="title">34</div>
                <div class="title">26%</div>
              </div>
            </div>
          </el-card>
          <el-card body-style="{ margin-bottom: '20px'}">
            <div slot="header">
              <span>会员车型统计</span>
            </div>
            <div id="pie" style="width: 300px; height: 300px;"></div>
            <div class="data_list">
              <div class="li">
                <div class="title ftw_bold">等级</div>
                <div class="title ftw_bold">数量</div>
                <div class="title ftw_bold">占比</div>
              </div>
              <div class="li">
                <div class="title">品牌一</div>
                <div class="title">10</div>
                <div class="title">20%</div>
              </div>
              <div class="li">
                <div class="title">品牌二</div>
                <div class="title">34</div>
                <div class="title">26%</div>
              </div>
            </div>
          </el-card>
          <el-card>
            <div slot="header">
              <span>会员年龄统计</span>
            </div>
            <div id="pie1" style="width: 300px; height: 300px;"></div>
            <div class="data_list">
              <div class="li">
                <div class="title ftw_bold">等级</div>
                <div class="title ftw_bold">数量</div>
                <div class="title ftw_bold">占比</div>
              </div>
              <div class="li" v-for="(item,index) in olds" :key="index">
                <div class="title">{{item.title}}</div>
                <div class="title">{{item.total}}</div>
                <div class="title">{{item.rang}}</div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<style>
.el-card__body {
  display: flex;
  justify-content: center;
}

.data_list {
  width: 50%;
  display: flex;
  align-items: start;
  flex-direction: column;
}

.data_list .li {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #bbbbbb;
  line-height: 50px;
  height: 50px;
}

.data_list .title {
  width: 33.3%;
  text-align: center;
}

.users_list {
  padding: 0 5%;
  width: 100%;
  display: flex;
  align-items: start;
  background: #ffffff;
}

.users_list .title {
  width: 100%;
  border-bottom: 1px solid #bbbbbb;
  line-height: 50px;
  height: 50px;
  text-align: center;
}

.el-card {
  margin-bottom: 20px;
}

/* .users_list:first-child {
  padding-top: 30px;
} */

/* .users_list:last-child {
  padding-bottom: 30px;
} */

.box-cell {
  overflow: hidden;
  color: #303133;
  transition: 0.3s;
  height: 140px;
  padding: 10px 20px 20px 20px;
  background-color: #fff;
  border-radius: 10px;
}

.box-cell .box-icon {
  background-color: #5ad8a6;
  height: 60px;
  width: 60px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

.box-cell .box-title {
  display: flex;
  flex-direction: column;
  width: 60%;
}

.box-cell .box-title .online {
  line-height: 30px;
  font-size: 32px;
  font-weight: bold;
}

.box-cell .box-title .yestaday {
  line-height: 26px;
  font-size: 14px;
  color: #999999;
}

.gl-count {
  flex: 1;
  text-align: center;
}

.gl-count p:nth-child(1) {
  font-size: 14px;
  line-height: 23px;
  margin-bottom: 16px;
  color: #666;
}

.gl-count p:nth-child(2) {
  font-size: 38px;
  line-height: 35px;
  color: #1676eb;
  font-weight: bold;
}

.gl-count p:nth-child(2):after {
  box-sizing: border-box;
}

.box-cell .box-icon-bg1 {
  background-color: #5ad8a6;
}

.box-cell .box-icon-bg2 {
  background-color: #81d3f8;
}

.box-cell .box-icon-bg3 {
  background-color: #c280ff;
}

.box-cell .box-icon-bg4 {
  background-color: #ffa94c;
}
</style>
<script>
import countTo from "vue-count-to";
import china from "echarts/map/json/china.json";
export default {
  components: { countTo },
  data() {
    this.chartExtend = {
      legend: { show: false }, //隐藏legend
      series: {
        center: ["50%", "50%"],
      },
    };

    this.chartSettings22 = {
      position: "china", //位置  默认china  填写省市 要带province
      labelMap: {
        people: "人口", //修改指标名称
      },
      itemStyle: {
        normal: {
          //不选中样式
          borderColor: "#fff",
          areaColor: "#E6EFFF", //背景颜色
        },
        emphasis: {
          //选中样式
          areaColor: "#6A9FFF",
        },
      },
      label: {
        //文本设置
        show: true,
        fontSize: 8,
        fontWeight: 300,
        color: "#9498AC",
      },
    };
    return {
      user_total: 0,
      user_online: 0,
      user_active: 0,
      user_vip: 0,
      user_svip: 0,
      user_unvip: 0,
      city_series: [],
      province: [],
      nameMap: [],
      olds: [],
      olds_series: [],
      loading: {
        loading: true,
      },
    };
  },
  created() {
    this.getIndex();
    //this.loading.loading = false;
  },
  mounted() {},
  methods: {
    /**
     * 地图数据
     */
    randomData: function () {
      return Math.round(Math.random() * 1000);
    },

    drawChart() {
      let myChart = this.$echarts.init(document.getElementById("pie"));
      let option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "5%",
          left: "center",
        },
        color: ["#52c1f5", "#ff7a8c"],
        series: [
          {
            type: "pie",
            radius: ["40%", "60%"],
            data: [
              { value: this.user_unvip, name: "普通用户" },
              { value: this.user_vip, name: "VIP会员" },
            ],
          },
        ],
      };

      myChart.setOption(option);
    },

    drawChart1() {
      let myChart = this.$echarts.init(document.getElementById("pie1"));
      let option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "5%",
          left: "center",
        },
        // color: ["#52c1f5", "#ff7a8c"],
        series: [
          {
            type: "pie",
            radius: ["40%", "60%"],
            data: this.olds_series,
            label: {
              show: false,
              position: "center",
            },
          },
        ],
      };

      myChart.setOption(option);
    },

    drawChart2() {
      let myChart = this.$echarts.init(document.getElementById("pie2"));
      let option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "5%",
          left: "center",
        },
        color: ["#52c1f5", "#ff7a8c"],
        series: [
          {
            type: "pie",
            radius: ["40%", "60%"],
            data: [
              { value: this.user_unvip, name: "普通用户" },
              { value: this.user_vip, name: "VIP会员" },
            ],
          },
        ],
      };

      myChart.setOption(option);
    },

    drawChart3() {
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
      let myChart = this.$echarts.init(document.getElementById("maps"));
      this.$echarts.registerMap("china", china);
      // 指定图表的配置项和数据
      let option = {
        title: {
          text: "会员地区分布",
        },
        tooltip: {
          trigger: "item",
        },
        toolbox: {
          show: true,
          orient: "vertical",
          left: "right",
          top: "center",
          feature: {
            dataView: { readOnly: false },
            restore: {},
            saveAsImage: {},
          },
        },
        legend: {
          orient: "horizontal", //图例的排列方向
          textStyle: { color: "#ccc" },
          x: "left", //图例的位置
          y: "-20000000000000",
        },
        visualMap: {
          min: 0,
          max: 10,
          text: ["High", "Low"],
          realtime: false,
          calculable: true,
          inRange: {
            color: ["#f5f5f5", "#86cfff", "#049bff"],
          },
        },
        roamController: {
          //控制地图的上下左右放大缩小
          show: true,
          x: "right",
          mapTypeControl: {
            china: true,
          },
        },
        series: [
          {
            name: "全国数据",
            type: "map",
            mapType: "china",
            zoom: 1.1, //地图大小
            roam: false, //是否开启鼠标缩放和平移漫游
            itemStyle: {
              //地图区域的多边形 图形样式
              normal: {
                //是图形在默认状态下的样式
                label: {
                  show: true,
                  textStyle: { color: "#000000" }, //地图text样式
                },
              },
              emphasis: {
                //是图形在高亮状态下的样式,比如在鼠标悬浮或者图例联动高亮时
                areaColor: "#6A9FFF",
                label: { show: true },
              },
            },
            top: "100", //组件距离容器的距离
            data: this.city_series,
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },

    getIndex() {
      const that = this;
      that.axios.post("/users/data").then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.user_total = res.data.user_total;
          this.user_online = res.data.user_online;
          this.user_active = res.data.user_active;
          this.user_vip = res.data.user_vip;
          this.user_svip = res.data.user_svip;
          this.user_unvip = res.data.user_unvip;
          this.city_series = res.data.city_series;
          this.province = res.data.province;
          this.nameMap = res.data.nameMap;
          this.olds_series = res.data.olds_series;
          this.olds = res.data.olds;
          this.loading.loading = false;
          this.drawChart();
          this.drawChart1();
          this.drawChart2();
          this.drawChart3();
        } else {
          this.loading.loading = false;
          that.$message.error(res.msg);
        }
      });
    },
  },
};
</script>
